import type { FC } from 'react';

import { copyrightStyle } from '@/features/storefront/appearance';
import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { useShopContent } from '@/features/storefront/content/useContent';
import { LanguageSwitcherSlot } from '@/features/storefront/i18n/LanguageSwitcher';
import { AppStoreBadges } from '@/features/storefront/layouts/chrome/FooterExtras';
import { InstallAppSlot } from '@/features/storefront/pwa/InstallAppSlot';
import {
  FallbackLinks,
  MenuLink,
} from '@/features/storefront/layouts/chrome/ChromeParts';
import { menuItems, type FooterProps } from '@/features/storefront/layouts/chrome/types';

/** Today's storefront footer: everything centered in one quiet block. */
export const Footer: FC<FooterProps> = ({ storeName, footer, menu, preview }) => {
  const items = menuItems(menu);
  const copy = useShopContent();
  return (
    <footer
      className="border-t py-8 text-center text-sm"
      style={{ borderColor: 'var(--storefront-surface)', color: 'var(--storefront-muted)' }}
    >
      <StorefrontContainer>
        {items.length > 0 ? (
          <nav
            aria-label={menu?.name}
            className="mb-4 flex flex-wrap justify-center gap-x-5 gap-y-2"
          >
            {items.map((item) => (
              <MenuLink
                key={`${item.label}:${item.url}`}
                item={item}
                preview={preview}
                className="hover:opacity-70"
              />
            ))}
          </nav>
        ) : (
          <FallbackLinks preview={preview} />
        )}
        <InstallAppSlot preview={preview} className="mb-4 justify-center" />
        <AppStoreBadges footer={footer} preview={preview} className="mb-4 justify-center" />
        <LanguageSwitcherSlot placement="footer" preview={preview} className="mb-4 justify-center" />
        <p style={copyrightStyle(footer)}>
          {storeName} · {copy('theme.powered_by', { brand: 'NeonCarts' })}
        </p>
      </StorefrontContainer>
    </footer>
  );
};
